import { styled } from "@mui/material";

export const ContainerActions = styled("div")`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: flex-end;
`;
